export const createManifestUrl = ({ domain, organizationName }: WhiteLabellingContentRequestPayload): string => {
    const query = new URLSearchParams();
    if (domain) query.set("domain", domain);
    if (organizationName) query.set("organizationName", organizationName);
    const search = query.toString();
    return search ? `/_platform/manifest?${search}` : "/_platform/manifest";
};
